import { render, staticRenderFns } from "./videoUploadHandler.vue?vue&type=template&id=2d3d57af&scoped=true"
import script from "./videoUploadHandler.vue?vue&type=script&lang=js"
export * from "./videoUploadHandler.vue?vue&type=script&lang=js"
import style0 from "./videoUploadHandler.vue?vue&type=style&index=0&id=2d3d57af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d57af",
  null
  
)

export default component.exports